module.exports = __webpack_public_path__ + "img/nav-41.727beb04.png";